// extracted by mini-css-extract-plugin
export var subtitle = "_9b-2";
export var title = "_9b-0";
export var titleNoWrap = "_9b-1";